import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyCMeX-0n9OVo1sUBFwrCz_L3v_ycYRKGbI',
  authDomain: 'lu-autonoma.firebaseapp.com',
  projectId: 'lu-autonoma',
  storageBucket: 'lu-autonoma.firebasestorage.app',
  messagingSenderId: '325773407731',
  appId: '1:325773407731:web:fb2ff2ebb770f9ec950e86',
  measurementId: 'G-W177WDHQBM',
};

export default async () => {
  if (typeof window === 'undefined') {
    return;
  }

  const app = initializeApp(firebaseConfig);
  if (await isSupported()) {
    getAnalytics(app);
  }
};
